import { useCallback } from "react";

import { useSelector } from "react-redux";

import { manageRecording } from "Services/ConversationsApiService";
import {
    selectIsConferenceRecording,
    selectSnapshotConferenceFriendlyID,
    selectSnapShotConferenceSid,
    selectConferenceSnapshotAgentCallSid,
} from "Services/state/conferences/ConferenceSnapshotSelectors";
import { toggleSnapshotRecording as toggleRecordingAction } from "Services/state/conferences/ConferenceSnapshotSlice";
import { useRVDispatch } from "Services/state/Storage";

import { logger } from "../../CallBar.utils";

export type UseRecordCallResult = { isRecording: boolean; toggleRecording: () => void; recordingDisabled?: boolean };

export const useCallActionRecord = (): UseRecordCallResult => {
    const dispatch = useRVDispatch();

    const isRecording = useSelector(selectIsConferenceRecording);
    const callSid = useSelector(selectConferenceSnapshotAgentCallSid);
    const conferenceFriendlyId = useSelector(selectSnapshotConferenceFriendlyID);
    const conferenceSid = useSelector(selectSnapShotConferenceSid);
    const recordingDisabled = !(conferenceFriendlyId && callSid && conferenceSid);

    const toggleRecording = useCallback(() => {
        if (!callSid || !conferenceFriendlyId) {
            logger.error("Tried to toggle recording but no active call found", {
                callSid,
                conferenceSid,
                conferenceFriendlyId,
            });

            return;
        }

        const [nextStatus] = isRecording ? (["paused", false] as const) : (["in-progress", true] as const);

        return manageRecording({
            callSid,
            status: nextStatus,
            conferenceSid,
            conferenceFriendlyId,
        }).then(() => dispatch(toggleRecordingAction()));
    }, [callSid, conferenceFriendlyId, isRecording, conferenceSid, dispatch]);

    return { isRecording, toggleRecording, recordingDisabled };
};
